import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { Deployment } from '@/app/app/interfaces/api/deployment';
import { DeploymentRemoteLocation } from '@/app/app/interfaces/api/deployment-remote-location';
import { environment } from '@/app/environments/environment';
import { Hierarchical } from '@/shared/lib/core/utils/hierarchical';

@Service()
export class DeploymentsApi {
  http = inject(HttpClient);

  public getDeploymentDataFromApi(): Observable<Deployment[]> {
    return this.http.get<Deployment[]>(`${environment.data.baseUrl}/deployments/extended`).pipe(map(result => {
      return result && result.length
        ? Hierarchical.sortByLevel(result)
        : result;
    }));
  }

  public setRemoteStartLocation(data: DeploymentRemoteLocation): Observable<any> {
    return this.http.post(`${environment.data.baseUrl}/deployments/SetRemoteLocation`, data);
  }
}
